<template>
	<div>
		<svg version="1.1" id="Layer_1_the_playlist_generation_logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 278.1 60" enable-background="new 0 0 278.1 60" xml:space="preserve">
	<g transform="scale(1)">
	<polygon :fill="fontColor" points="0,8.7 0,9.5 2.2,9.5 2.2,15 3.2,15 3.2,9.5 5.4,9.5 5.4,8.7 "></polygon>
	<polygon :fill="fontColor" points="12.7,15 12.7,12.1 9.4,12.1 9.4,15 8.5,15 8.5,8.7 9.4,8.7 9.4,11.3 12.7,11.3 12.7,8.7 13.6,8.7	13.6,15 "></polygon>
	<polygon :fill="fontColor" points="16.9,15 16.9,8.7 21.6,8.7 21.6,9.5 17.9,9.5 17.9,11.3 21.4,11.3 21.4,12.1 17.9,12.1 17.9,14.2	21.6,14.2 21.6,15 "></polygon>
	<g>
		<defs>
			<rect id="SVGID_1_the_playlist_generation_logo" width="278.1" height="60"></rect>
		</defs>
		<clipPath id="SVGID_2_the_playlist_generation_logo">
			<use xlink:href="#SVGID_1_the_playlist_generation_logo" overflow="visible"></use>
		</clipPath>
		<path clip-path="url(#SVGID_2_the_playlist_generation_logo)" :fill="fontColor" d="M42.7,10.2h3.5c3.5,0,5.8-0.5,5.8-3.7c0-3.4-2.6-3.5-5.4-3.5h-3.9V10.2z		 M39.4,21.5V0.3h7.8c4.9,0,8,1.6,8,6.1c0,4.7-3.7,6.4-8.8,6.4h-3.7v8.7H39.4z"></path>
	</g>
	<polygon :fill="fontColor" points="67.4,0.3 67.4,21.5 81.9,21.5 81.9,18.7 70.7,18.7 70.7,0.3 "></polygon>
	<path :fill="fontColor" d="M103.6,5.2l3.7,8.3h-7.4L103.6,5.2z M102.7,0.3l-9.4,21.3h3.4l2.3-5.3h9.2l2.4,5.3h3.4l-9.2-21.3H102.7z"></path>
	<polygon :fill="fontColor" points="138.3,0.3 131.8,11.1 125.3,0.3 121.6,0.3 130.1,14.1 130.1,21.5 133.2,21.5 133.2,14.1 141.8,0.3	"></polygon>
	<polygon :fill="fontColor" points="153,0.3 153,21.5 167.5,21.5 167.5,18.7 156.2,18.7 156.2,0.3 "></polygon>
	<rect x="180.6" y="0.3" :fill="fontColor" width="3.2" height="21.3"></rect>
	<g>
		<defs>
			<rect id="SVGID_3_the_playlist_generation_logo" width="278.1" height="60"></rect>
		</defs>
		<clipPath id="SVGID_4_the_playlist_generation_logo">
			<use xlink:href="#SVGID_3_the_playlist_generation_logo" overflow="visible"></use>
		</clipPath>
		<path clip-path="url(#SVGID_4_the_playlist_generation_logo)" :fill="fontColor" d="M203,21.7c-3.8-0.1-6.6-2.2-7.2-5.6l2.5-0.8c0.6,2.2,2.3,3.6,4.8,3.6		c2.4,0.1,4-1.2,4-3.3c0.1-2.2-1.8-2.9-4.4-4c-2-0.8-3.4-1.7-4.4-2.6c-2-2.1-1.6-5.8,0.6-7.7c1.4-1.1,2.9-1.5,4.7-1.4		c2.5,0.1,4.5,1.2,6.1,3.4l-2.3,1.9c-1.1-1.7-2.2-2.5-3.9-2.6c-1-0.1-1.9,0.2-2.5,0.7c-1.2,0.9-1.4,2.4-0.5,3.4		c0.6,0.7,1.3,1.2,3.2,2c2.3,1,6.3,2.2,6.3,6.9C210,19.5,206.9,21.8,203,21.7"></path>
	</g>
	<polygon :fill="fontColor" points="220.6,0.3 220.6,3.1 228.1,3.1 228.1,21.5 231.3,21.5 231.3,3.1 238.7,3.1 238.7,0.3 "></polygon>
	<g>
		<defs>
			<rect id="SVGID_5_the_playlist_generation_logo" width="278.1" height="60"></rect>
		</defs>
		<clipPath id="SVGID_6_the_playlist_generation_logo">
			<use xlink:href="#SVGID_5_the_playlist_generation_logo" overflow="visible"></use>
		</clipPath>
		<path clip-path="url(#SVGID_6_the_playlist_generation_logo)" :fill="fontColor" d="M20,47.1v12.6h-2.8v-3.1c-1.8,2.2-4,3.4-6.8,3.4c-2.9,0-5.5-1-7.5-3.1		c-1.9-2-2.9-4.7-2.9-8c0-2.9,1-5.7,2.9-7.7c1.9-2,4.6-3,7.4-3c3.6,0,6,1.3,8.2,4.2l-2.4,1.9C15,42.1,13.1,41,10.4,41c-2.2,0-4,0.7-5.3,2.2c-1.3,1.5-2,3.5-2,5.7c0,2.5,0.7,4.5,2,6.1c1.3,1.5,3.1,2.2,5.3,2.2c3.1,0,6.4-2.5,6.4-6.6v-0.7h-6.4v-2.8H20z"></path>
	</g>
	<polygon :fill="fontColor" points="34,38.5 34,59.7 49.7,59.7 49.7,56.9 37.2,56.9 37.2,49.9 48.9,49.9 48.9,47.3 37.2,47.3 37.2,41.2	49.7,41.2 49.7,38.5 "></polygon>
	<polygon :fill="fontColor" points="76.5,38.5 76.5,54.2 66.6,38.5 63,38.5 63,59.7 66.1,59.7 66.1,43.4 76.4,59.7 79.6,59.7 79.6,38.5	"></polygon>
	<polygon :fill="fontColor" points="93.7,38.5 93.7,59.7 109.3,59.7 109.3,56.9 96.8,56.9 96.8,49.9 108.5,49.9 108.5,47.3 96.8,47.3	96.8,41.2 109.3,41.2 109.3,38.5 "></polygon>
	<g>
		<defs>
			<rect id="SVGID_7_the_playlist_generation_logo" width="278.1" height="60"></rect>
		</defs>
		<clipPath id="SVGID_8_the_playlist_generation_logo">
			<use xlink:href="#SVGID_7_the_playlist_generation_logo" overflow="visible"></use>
		</clipPath>
		<path clip-path="url(#SVGID_8_the_playlist_generation_logo)" :fill="fontColor" d="M125.6,48.4h3.2c3.5,0,6.1-0.5,6.1-3.7c0-3.4-2.6-3.5-5.4-3.5h-3.9V48.4z		 M135.7,59.7l-6.2-8.7c-0.1,0-0.3,0-0.4,0h-3.4v8.7h-3.3V38.5h7.8c4.9,0,8,1.6,8,6.1c0,3.4-2,5.2-5,6l6.2,9.1H135.7z"></path>
	</g>
	<path :fill="fontColor" d="M160.5,43.4l3.7,8.3h-7.4L160.5,43.4z M159.6,38.5l-9.4,21.3h3.4l2.3-5.3h9.2l2.4,5.3h3.4l-9.2-21.3H159.6z"></path>
	<polygon :fill="fontColor" points="179,38.5 179,41.2 186.4,41.2 186.4,59.7 189.7,59.7 189.7,41.2 197.1,41.2 197.1,38.5 "></polygon>
	<rect x="210.4" y="38.4" :fill="fontColor" width="3.2" height="21.3"></rect>
	<g>
		<defs>
			<rect id="SVGID_9_the_playlist_generation_logo" width="278.1" height="60"></rect>
		</defs>
		<clipPath id="SVGID_10_the_playlist_generation_logo">
			<use xlink:href="#SVGID_9_the_playlist_generation_logo" overflow="visible"></use>
		</clipPath>
		<path clip-path="url(#SVGID_10_the_playlist_generation_logo)" :fill="fontColor" d="M237.5,41c-2.2,0-4.2,0.7-5.6,2.2c-1.4,1.5-2.1,3.5-2.1,5.8		c0,2.5,0.7,4.5,2.1,6c1.3,1.4,3.2,2.2,5.6,2.2c2.3,0,4.1-0.7,5.6-2.2c1.4-1.5,2.1-3.5,2.1-6c0-2.4-0.6-4.2-2.1-5.9		C241.6,41.7,239.7,41,237.5,41 M237.5,60c-3.1,0-5.8-1-7.8-2.9c-2.2-2.2-3.2-4.9-3.2-8.1c0-3.1,1.1-5.9,3.1-7.9		c1-1,2.2-1.7,3.4-2.2c1.3-0.5,2.8-0.7,4.4-0.7c3.1,0,5.7,0.8,7.8,2.9c2.1,2.1,3.2,4.9,3.2,7.9c0,3.3-1.1,6-3.2,8.1		C243.3,59.1,240.5,60,237.5,60"></path>
	</g>
	<polygon :fill="fontColor" points="274.9,38.5 274.9,54.2 265.1,38.5 261.5,38.5 261.5,59.7 264.6,59.7 264.6,43.4 274.8,59.7	278.1,59.7 278.1,38.5 "></polygon>
	<g>
		<defs>
			<rect id="SVGID_11_the_playlist_generation_logo" width="278.1" height="60"></rect>
		</defs>
		<clipPath id="SVGID_12_the_playlist_generation_logo">
			<use xlink:href="#SVGID_11_the_playlist_generation_logo" overflow="visible"></use>
		</clipPath>
		<line clip-path="url(#SVGID_12_the_playlist_generation_logo)" fill="none" :stroke="lineColor" :stroke-width="lineWidth" x1="0" y1="30" x2="278.1" y2="30"></line>

	</g>
	</g>
	</svg>
	</div>
</template>

<script>
export default {
  props: ['defined-color', 'all-black'],
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  },
  computed: {
    fontColor() {
      if (!this.definedColor) {
        return '#000000';
      }
      return this.definedColor;
    },
    lineColor() {
      if (this.definedColor == '#fff' || this.definedColor == '#ffffff' || this.definedColor == 'white') {
        return '#fff';
      } if (this.allBlack === 'true') {
        return '#000';
      }
      return '#01ac81';
    },
    lineWidth() {
      if (this.definedColor == '#fff' || this.definedColor == '#ffffff' || this.definedColor == 'white') {
        return '2';
      }
      return '1';
    },
  },

};
</script>
